import { useQuery } from '@tanstack/react-query';

import { type ZoneUserAccess } from 'src/features/parkingManagement/types/zoneUserAccess';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/zone-user-access/';

interface DTO extends ListDTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<ZoneUserAccess>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useListZoneUserAccess };
